import React from "react";
import { createRoot } from "react-dom/client";
import SessionGate from "./SessionGate.jsx";
import "./styles.css";
import "./refinements.css";
createRoot(document.getElementById("root")).render(<SessionGate />);
if (import.meta.env.PROD && "serviceWorker" in navigator)
  navigator.serviceWorker.register("/sw.js").catch(() => {});
